import { defineMessages } from 'react-intl';
export const uploadGateMessages = defineMessages({
    authTitle: {
        defaultMessage: 'Sign in to upload files',
        description: 'Title of the visitor login upsell modal shown when an unauthenticated user tries to upload a file',
        id: '2f9127e695',
    },
    authDescription: {
        defaultMessage: 'Upload PDFs, docs, and images to get instant analysis and answers.',
        description: 'Description of the visitor login upsell modal shown when an unauthenticated user tries to upload a file',
        id: '4186dffbaf',
    },
    rateLimitTitle: {
        defaultMessage: 'Upgrade for additional document analysis',
        description: 'Title of the paywall upsell modal shown when a user exceeds the file upload rate limit',
        id: 'fbb842a03b',
    },
    proRateLimitTitle: {
        defaultMessage: "You've reached the weekly file upload limit",
        description: 'Title of the paywall upsell modal shown when a Pro user exceeds the file upload rate limit',
        id: 'a3c4e80fa5',
    },
});
//# sourceMappingURL=uploadGateMessages.js.map